module.exports = __webpack_public_path__ + "static/notification-groups-delete-1-c432de0c2ace38d3b50e14b6a5cf1807.png";